import React from 'react';
import ReactDOM from 'react-dom/client';
import './index.css';
import App from './App';
import {ChakraProvider, ColorModeScript, extendTheme} from "@chakra-ui/react";
import {BrowserRouter} from "react-router-dom";
import {createDefaultAdapter} from "./adapters";

const root = ReactDOM.createRoot(document.getElementById('root'));
const adapter = createDefaultAdapter();

const config = {
  initialColorMode: "dark",
  useSystemColorMode: false,
};

const theme = extendTheme({
  config,
  colors: {
    studio: {
      50: "#fffbe8",
      100: "#fff4b8",
      200: "#ffe979",
      300: "#ffd84d",
      400: "#f2c22f",
      500: "#d9a818",
      600: "#ad8210",
      700: "#7c5c0d",
      800: "#4e3a0c",
      900: "#2b210a",
    },
  },
  fonts: {
    heading: "Inter, ui-sans-serif, system-ui, sans-serif",
    body: "Inter, ui-sans-serif, system-ui, sans-serif",
    mono: "SFMono-Regular, Menlo, Monaco, Consolas, monospace",
  },
  radii: {
    md: "6px",
    lg: "8px",
  },
  styles: {
    global: {
      body: {bg: "#08090a", color: "#f2f3f4"},
      "::selection": {bg: "studio.300", color: "#111214"},
    },
  },
  components: {
    Button: {
      baseStyle: {fontWeight: "700", borderRadius: "5px"},
    },
    Input: {
      defaultProps: {focusBorderColor: "studio.300"},
    },
    Select: {
      defaultProps: {focusBorderColor: "studio.300"},
    },
    Textarea: {
      defaultProps: {focusBorderColor: "studio.300"},
    },
    Tooltip: {
      baseStyle: {borderRadius: "4px", fontSize: "xs"},
    },
  },
});

root.render(
  <React.StrictMode>
    <BrowserRouter basename="/">
      <ChakraProvider theme={theme}>
        <ColorModeScript initialColorMode={theme.config.initialColorMode} />
        <App adapter={adapter} />
      </ChakraProvider>
    </BrowserRouter>
  </React.StrictMode>
);
